import { styled } from '@mui/system';
import { ButtonGroup as MuiButtonGroup } from '@mui/material';
import colors from '../../../assets/colors';

const StyledButtonGroup = styled(MuiButtonGroup)({
  color: colors.agroweGreen,
  '& .MuiButtonGroup-groupedContained': {
    backgroundColor: colors.agroweGreen,
    '&:not(:last-child)': {
      borderRight: `1px solid ${colors.white}`,
    },
    '&:hover': {
      opacity: 0.8,
      backgroundColor: colors.agroweGreen,
    },
  },
});

const ButtonGroup = (props) => (
  <StyledButtonGroup variant="contained" {...props} />
);
export default ButtonGroup;
